import React, { useEffect } from "react";
import { SkipToContent } from "@/components/site/SkipToContent";
import { StickyHeader } from "@/components/site/StickyHeader";
import { ContactHero } from "@/components/site/contact/ContactHero";
import { ContactSection } from "@/components/site/contact/ContactSection";
import { SiteFooter } from "@/components/site/SiteFooter";
import { SubscribeSection } from "@/components/site/SubscribeSection";

export default function ContactPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <SkipToContent />
      <StickyHeader overlay linkToHome />
      <main id="content" tabIndex={-1} className="outline-none">
        <ContactHero />
        <ContactSection />
        <SubscribeSection id="email-list" testidPrefix="contact-subscribe" className="border-y-4 border-[var(--wf-maroon)] bg-[var(--wf-wheat)]/40" />
      </main>
      <SiteFooter />
    </>
  );
}
